import { useEffect, useState } from "react";

export default function useTypewriter(words, speed = 80, pause = 1800) {
  const [text, setText] = useState("");
  const [wordIdx, setWordIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const word = words[wordIdx];
    let delay = deleting ? 42 : speed;
    if (!deleting && charIdx === word.length) delay = pause;
    else if (deleting && charIdx === 0) {
      setDeleting(false);
      setWordIdx((i) => (i + 1) % words.length);
      return;
    }
    const t = setTimeout(() => {
      setText(word.slice(0, charIdx + (deleting ? -1 : 1)));
      setCharIdx((i) => i + (deleting ? -1 : 1));
      if (!deleting && charIdx + 1 === word.length) setDeleting(true);
    }, delay);
    return () => clearTimeout(t);
  }, [charIdx, deleting, wordIdx, words, speed, pause]);

  return text;
}
